module.exports = __webpack_public_path__ + "static/media/map.13e74bbb.jpg";